export enum AppNameEnum {
    GAN_PREV        = 'GAN_PREV',
    GAN_PAT         = 'GAN_PAT',
    GROUPAMA        = 'GROUPAMA'
}
